import { encodeSpecialCharacters, flattenArray, generateHash } from './utils';
/**
 * Экземлят тега VirtualDOM
 */
export class Tag {
    static fromJson(serialized) {
        return new Tag(serialized.type, serialized.props, serialized.children);
    }
    constructor(type, props, children) {
        this.type = type;
        this.props = props;
        if (children) {
            this.children = (() => {
                if (Array.isArray(children)) {
                    return children.map(child => {
                        if (typeof child === 'string')
                            return child;
                        if (child instanceof Tag)
                            return child;
                        return Tag.fromJson(child);
                    });
                }
                if (typeof children === 'string')
                    return children;
                if (children instanceof Tag)
                    return children;
                return Tag.fromJson(children);
            })();
        }
    }
    /**
     * Добавить свойство
     * @param {string} name название свойства
     * @param {TagPropValue} value значение свойства
     */
    addProp(name, value) {
        this.props[name] = value;
    }
    /**
     * Удалить свойство
     * @param {string} name название свойства
     */
    removeProp(name) {
        if (this.props[name]) {
            delete this.props[name];
        }
    }
    /**
     * Обьединить свойства
     * @param {TagProps} newProps обьект с новыми свойствами
     */
    mergeProps(newProps) {
        this.props = {
            ...this.props,
            ...newProps,
        };
    }
    /**
     * Получить хеш текущего тега
     * @return {string}
     */
    getHash() {
        let t = `${this.type}`;
        Object.keys(this.props)
            .sort()
            .forEach(prop => {
            t += `[${prop.toLowerCase()}="${encodeSpecialCharacters(this.props[prop].toString())}"]`;
        });
        if (this.children) {
            t += flattenArray(this.children);
        }
        return generateHash(t);
    }
    /**
     * Аттрибуты тега строкой
     * @return {string}
     */
    elementAttrToString() {
        return Object.entries(this.props).reduce((memo, [key, value]) => {
            let prop = typeof value !== 'undefined' ? ` ${key}="${encodeSpecialCharacters(value.toString())}"` : ` ${key}`;
            return memo + prop;
        }, '');
    }
    /**
     * Тег строкой
     * @return {string}
     */
    toString() {
        const props = this.elementAttrToString();
        if (!!this.children || this.type === 'script') {
            return `<${this.type}${props}>${flattenArray(this.children || '')}</${this.type}>`;
        }
        return `<${this.type}${props}/>`;
    }
    /**
     * Сериализованный обьект тега
     */
    toJSON() {
        let children = [];
        if (this.children) {
            children = Array.isArray(this.children) ? this.children : [this.children];
        }
        return {
            type: this.type,
            props: this.props,
            children: children.map(child => (child instanceof Tag ? child.toJSON() : child)),
        };
    }
    /**
     * HTML элемент тега
     * @return {HTMLElement}
     */
    toHTMLElement() {
        const newElement = document.createElement(this.type);
        Object.entries(this.props).forEach(([k, v]) => {
            newElement.setAttribute(k, String(v) || '');
        });
        if (this.children) {
            if (this.type === 'style') {
                newElement.appendChild(document.createTextNode(flattenArray(this.children)));
            }
            else {
                newElement.innerHTML = flattenArray(this.children);
            }
        }
        return newElement;
    }
}
